module.exports = __webpack_public_path__ + "img/background042.77ae3de9.jpg";